import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import Table from '../table/Table';
import { capitalizeFirstLetter } from '../../utils/api';
import { iconPaths } from '../../constants/iconsList';
import { formatLastVisit, formatNumericDate } from '../../utils/dates';

const SitesTable = ({ sites, onSort }) => {
  const siteIcon = (icon) => {
    const iconName = icon || 'default';
    return (
      <div className="text-vamos-black">
        <Icon className="material-symbols-outlined" path={iconPaths[iconName]} size={0.8} />
      </div>
    );
  };
  const newSites = sites.map((site) => {
    let siteContact = '';
    let sitePriority = site.priority;
    let h2a = null;
    if (site.primary_contact_id) {
      siteContact = site.contacts.find((contact) => contact.id === site.primary_contact_id);
    }
    if (site.priority === 'no_priority') {
      sitePriority = 'No priority';
    }
    if (site.h2a) {
      h2a = 'Yes';
    } else if (site.h2a === false) {
      h2a = 'No';
    }
    return {
      id: site.id,
      icon: siteIcon(site?.icon),
      name: site?.name || '',
      created_at: formatNumericDate(site.created_at),
      status: capitalizeFirstLetter(site?.status) || '',
      priority: capitalizeFirstLetter(sitePriority) || '',
      county: site?.county || '',
      h2a: (h2a === null) ? 'No data' : h2a,
      primary_contact_name: siteContact?.name || '',
      address1: site?.address1 || '',
      last_visit: formatLastVisit(site.last_visit) || 'No visits',
    };
  });

  const columns = [
    {
      title: 'Icon', dataIndex: 'icon', className: 'flex-none', isSortable: true,
    },
    {
      title: 'Name', dataIndex: 'name', className: 'flex-2', isSortable: true,
    },
    {
      title: 'Created', dataIndex: 'created_at', className: 'flex-1', isSortable: true,
    },
    {
      title: 'Status', dataIndex: 'status', className: 'flex-1', isSortable: true,
    },
    {
      title: 'Priority', dataIndex: 'priority', className: 'flex-1', isSortable: true,
    },
    {
      title: 'County', dataIndex: 'county', className: 'flex-1', isSortable: true,
    },
    {
      title: 'h2a', dataIndex: 'h2a', className: 'flex-1', isSortable: true,
    },
    {
      title: 'Primary contact', dataIndex: 'primary_contact_name', className: 'flex-1', isSortable: true,
    },
    {
      title: 'Address', dataIndex: 'address1', className: 'flex-1', isSortable: true,
    },
    {
      title: 'Last visit', dataIndex: 'last_visit', className: 'flex-1', isSortable: true,
    },
  ];

  // to avoid rendering the table if there are no sites
  if (!newSites) {
    return null;
  }

  return (
    <div>
      <Table
        dataSource={newSites}
        columns={columns}
        typeOfData="sites"
        onSort={(values) => {
          onSort(values.field, values.order);
        }}
      />
    </div>
  );
};

SitesTable.propTypes = {
  sites: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSort: PropTypes.func.isRequired,
};

export default SitesTable;
